/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-06 17:33:24
 * @LastEditors: linxi
 * @LastEditTime: 2025-06-24 10:18:58
 */
import { Button, Col, Form, Input, Row, Select, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import { SearchOutlined, CaretDownFilled } from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import {
  DateRangeFieldName,
  DateRangeType,
  DateSelect,
  getDateRange,
} from '../../compnents/form/DateSelect'
import { InventoryPriceParams } from '../../services/InventPrice'

const { Option } = Select

export const InventoryQuery = (props: {
  exportLoading?: boolean
  loading?: any
  table: any
  onValueChange: (queries: InventoryPriceParams) => void
  outClued: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch()

  const [show, setShow] = useState(false)

  useEffect(() => {
    const [head, tail] = getDateRange(DateRangeType.Today)
    // form.setFieldsValue({
    //   timeHead: head,
    //   timeTail: tail,
    // });
    form.submit()
  }, [])

  return (
    <Form
      form={form}
      name='control-hooks'
      autoComplete='off'
      // onFieldsChange={(_, fs) => {
      //   dispatch(setPriceCurrent(1));
      //   props.onValueChange({
      //     ...form.getFieldsValue(),
      //     executeDateStart: form.getFieldsValue().registrationTimeHead,
      //     executeDateEnd: form.getFieldsValue().registrationTimeTail,
      //     registrationTimeHead: null,
      //     registrationTimeTail: null,
      //   });
      // }}
      onFinish={(values) => props.onValueChange(values)}
    >
      <Row style={{ margin: '0 0 10px 0' }} justify='space-between'>
        <Space wrap={false}>
          <Form.Item name='name' noStyle>
            <Input
              onChange={() => form.submit()}
              placeholder='请输入物资名,助记码或条形码'
              style={{width:'16rem'}}
              prefix={<SearchOutlined />}
            />
          </Form.Item>
          <Form.Item name='state' noStyle>
            <Select
             style={{width:'8rem'}}
              onChange={(e) => {
                form.submit()
                setShow(e === 1)

                if (e !== 1) {
                  form.setFieldsValue({
                    timeHead: null,
                    timeTail: null,
                    _dateRange: null,
                  })
                }
              }}
              allowClear
              placeholder='执行状态'
              // suffixIcon={<CaretDownFilled />}
            >
              <Option value={0}>未执行</Option>
              <Option value={1}>执行</Option>
            </Select>
          </Form.Item>
          {show && (
            <Form.Item name='' noStyle>
              <DateSelect
                placeholder='执行时间'
                style={{ width: '8rem' }}
                labelPrefix=''
                // initialValue={DateRangeType.Today}
                namePrefix='time'
                onChange={() => form.submit()}
              />
            </Form.Item>
          )}
          <Button
            loading={props?.loading}
            type='primary'
            style={{  marginRight: '10px' }}
            onClick={() => form.submit()}
          >
            查询
          </Button>
        </Space>
        <Space>
          <Button
            loading={props?.exportLoading}
            onClick={() => props.outClued()}
            type='primary'
            style={{ width: '64px' }}
          >
            导出
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
